// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview {
  background: #fff;
  border-radius: 4px;
  padding: 1rem 1.5rem;
  margin: 30px 0 0 0;
}
.overview ul {
  list-style: none;
  padding: 0;
  height: 310px;
  overflow: auto;
}
.overview .title {
  font-size: 19px;
  text-align: center;
  color: #333;
  margin-top: 0;
}
.overview li {
  display: flex;
  max-width: calc(100% - 1rem);
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.overview li .dash {
  height: 1px;
  background: #dedede;
  flex-grow: 1;
  transform: scaleX(0.8);
}
.overview li .name {
  display: flex;
  align-items: center;
  max-width: 80%;
}
.overview li .name p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
}
.overview li .dot {
  width: 8px;
  height: 8px;
  background: #2c72b6;
  border-radius: 50%;
  margin-right: 0.5rem;
  flex: 0 0 auto;
}

.placeholder {
  width: 100%;
  height: 400px;
  margin-top: 30px;
  border: 5px dashed #fff;
  border-radius: 5px;
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
